import type { ContactFormData } from './types';

export const sanitizeFormData = (data: ContactFormData): ContactFormData => {
  return {
    discipline: data.discipline.trim(),
    message: data.message.trim().replace(/\s+/g, ' '), // Replace multiple spaces with single space
    name: data.name.replace(/[\p{Emoji}]/gu, "").trim().replace(/\s+/g, ' '),
    email: data.email.trim().toLowerCase(),
    entityId: data.entityId
  };
};

export const generateMessagePreview = (message: string, maxLength: number = 50): string => {
  if (message.length <= maxLength) return message;
  return message.substring(0, maxLength).trim() + "...";
};

export const logContactFormEvent = (event: string, data?: Record<string, any>) => {
  // This can be used for analytics tracking similar to gtmEvent in auth component
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', event, {
      event_category: 'contact_form',
      ...data
    });
  }
};